<template>
  <CRow>
    <CCol cols="12">
      <CCard>
        <CCardHeader>
          <strong>Create Industries</strong>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol cols="12" class="mb-3">
              <CLabel class="font-weight-bold">Nama Industries</CLabel>
              <CInput v-model="form.name" />
            </CCol>
          </CRow>

          <CRow>
            <CCol cols="12" class="mb-3">
              <CLabel class="font-weight-bold">Slug</CLabel>
              <CInput v-model="form.slug" />
            </CCol>
          </CRow>

          <CRow>
            <CCol cols="12" class="mb-3">
              <CLabel class="font-weight-bold">Deskripsi</CLabel>
              <CInput v-model="form.description" />
            </CCol>
          </CRow>


          <!-- DESKTOP BANNER -->
          <CRow>
            <CCol cols="12" class="mb-4">
              <CLabel class="font-weight-bold">Desktop Banner</CLabel>
              <ImageUploader v-model="form.banner_desktop" />
              <small class="text-muted">
                Recommended size 1440 x 800px, max 2MB (JPG/JPEG/PNG/WebP)
              </small>
            </CCol>
          </CRow>

          <!-- MOBILE BANNER -->
          <CRow>
            <CCol cols="12" class="mb-4">
              <CLabel class="font-weight-bold">Mobile Banner</CLabel>
              <ImageUploader v-model="form.banner_mobile" />
              <small class="text-muted">
                Recommended size 432 x 768px, max 2MB (JPG/JPEG/PNG/WebP)
              </small>
            </CCol>
          </CRow>

          <!-- INDUSTRY ICON -->
          <CRow>
            <CCol cols="12" class="mb-4">
              <CLabel class="font-weight-bold">Industry Icon</CLabel>
              <ImageUploader v-model="form.industry_icon" />
              <small class="text-muted">
                Recommended size 56 x 56px, max 2MB (JPG/JPEG/PNG/WebP)
              </small>
            </CCol>
          </CRow>

          <!-- INDUSTRIES CHALLENGE -->
          <CRow>
            <CCol cols="12">
              <strong class="font-weight-bold">Industries Challenge</strong>
              <DynamicCrudTable
                  title=""
                  v-model="industriesChallenge"
                  :columns="challengeColumns"
              />
            </CCol>
          </CRow>

          <!-- INDUSTRIES IMAGE -->
          <CRow class="mt-4">
            <CCol cols="12">
              <CLabel class="font-weight-bold">Industries Image</CLabel>
              <ImageUploader v-model="form.image_industry" />

              <small class="text-muted">
                Recommended size 460 x 594px, max 2MB
              </small>
            </CCol>
          </CRow>

          <!-- INDUSTRIES IMAGE -->
          <CRow class="mt-4">
            <CCol cols="12">
              <CLabel class="font-weight-bold">Industries Image Mobile</CLabel>
              <ImageUploader v-model="form.industry_image_mobile" />

              <small class="text-muted">
                Recommended size 320 x 180px, max 2MB
              </small>
            </CCol>
          </CRow>

          <!-- SOLUTION -->
          <CRow class="mt-4">
            <CCol cols="12">
              <strong>Solution</strong>
              <DynamicCrudTable
                  title=""
                  v-model="solutions"
                  :columns="solutionColumns"
              />
            </CCol>
          </CRow>

          <!-- BENEFIT -->
          <CRow class="mt-4">
            <CCol cols="12">
              <strong>Benefit</strong>
              <DynamicCrudTable
                  title=""
                  v-model="benefits"
                  :columns="benefitColumns"
              />
            </CCol>
          </CRow>

          <!-- TESTIMONIAL -->
          <CRow class="mt-4">
            <CCol cols="12">
              <strong>Testimonial</strong>
              <DynamicCrudTable
                  title=""
                  v-model="testimonials"
                  :columns="testimonialColumns"
              />
            </CCol>
          </CRow>

          <!-- STATUS -->
          <CRow class="mt-4">
            <CCol cols="12">
              <CLabel>Status</CLabel>
              <CSelect
                  v-model="form.is_active"
                  :options="optionsStatus"
              />
            </CCol>
          </CRow>

          <CRow class="mt-3">
            <CCol cols="12">
              <CLabel>Hashtag</CLabel>
              <multiselect
                  v-model="form.hashtag_ids"
                  :options="optionsHashtag"
                  :multiple="true"
                  placeholder="Pilih hashtag"
                  @change="handleHashtag"
              />
            </CCol>
          </CRow>


          <!-- FAQ -->
          <CRow class="mt-4">
            <CCol cols="12">
              <strong>FAQ</strong>
              <DynamicCrudTable
                  title=""
                  v-model="faqs"
                  :columns="faqColumns"
              />
            </CCol>
          </CRow>
        </CCardBody>

        <!-- FOOTER -->
        <CCardFooter class="text-right">
          <CButton color="secondary" class="mr-2">
            Back
          </CButton>
          <CButton color="primary" @click="submit" :disabled="isDisableSubmit">
            Save
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import DynamicCrudTable from "@/components/DynamicCrudTable.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import axios from "axios";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";


export default {
  name: "IndustryCreateV2",
  components: {ImageUploader, DynamicCrudTable,Multiselect },

  data() {
    return {
      isDisableSubmit: false,
      slugAutoGenerated: true,
      form: {
        name: "",
        slug: "",
        is_active: "true",
        hashtag: "",
        description: "",
        industry_icon: null,
        banner_desktop: null,
        banner_mobile: null,
        image_industry: null,
        industry_image_mobile: null
      },

      industriesChallenge: [],
      solutions: [],
      benefits: [],
      testimonials: [],
      faqs: [],

      challengeColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "title", label: "Title", type: "text" },
        { key: "description", label: "Description", type: "text" }
      ],

      solutionColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "title", label: "Title", type: "text" },
        { key: "description", label: "Description", type: "text" },
        { key: "image", label: "Image", type: "image" },
        { key: "icon", label: "Icon", type: "image" }
      ],

      benefitColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "title", label: "Title", type: "text" },
        { key: "description", label: "Description", type: "text" },
        { key: "icon", label: "Icon", type: "image" }
      ],

      testimonialColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "name", label: "Name", type: "text" },
        { key: "testimoni", label: "Testimoni", type: "text" },
        { key: "company", label: "Company", type: "text" },
        { key: "image", label: "Image", type: "image" },
        { key: "video", label: "Video", type: "text" }
      ],

      faqColumns: [
        { key: "priority", label: "Priority", type: "number" },
        { key: "question", label: "Question", type: "text" },
        { key: "answer", label: "Answer", type: "text" }
      ],
      optionsHashtag: [],
      optionsStatus: [
        { label: "Active", value: "true" },
        { label: "Inactive", value: "false" }
      ]
    };
  },
  watch: {
    'form.name'(newName) {
      if (this.slugAutoGenerated) {
        this.form.slug = this.generateSlug(newName)
      }
    },
    'form.slug'(newSlug) {
      const expectedSlug = this.generateSlug(this.form.name)
      if (newSlug !== expectedSlug) {
        this.slugAutoGenerated = false
      } else {
        this.slugAutoGenerated = true
      }
    },
  },

  methods: {
    generateSlug(text) {
      if (!text) return ''
      return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/[\s]+/g, '-')
        .replace(/-{2,}/g, '-')
        .replace(/^-+|-+$/g, '')
    },
    async submit() {
      this.isDisableSubmit = true;

      const fd = new FormData();

      /* =========================
       * BASIC FIELD
       * ========================= */
      fd.append("name", this.form.name);
      fd.append("slug", this.form.slug);
      fd.append("is_active", this.form.is_active);
      fd.append("description", this.form.description);
      fd.append("industry_icon", this.form.industry_icon)

      /* =========================
       * FILE (TOP LEVEL)
       * ========================= */
      if (this.form.banner_desktop) {
        fd.append("banner_desktop", this.form.banner_desktop);
      }

      if (this.form.banner_mobile) {
        fd.append("banner_mobile", this.form.banner_mobile);
      }

      if (this.form.image_industry) {
        fd.append("image_industry", this.form.image_industry);
      }

      if (this.form.industry_image_mobile) {
        fd.append("industry_image_mobile", this.form.industry_image_mobile);
      }

      /* =========================
       * HASHTAG
       * ========================= */
      if (this.form.hashtag_ids && this.form.hashtag_ids.length) {
        fd.append("hashtag", this.form.hashtag_ids.join(","));
      }

      /* =========================
       * CHALLENGE
       * ========================= */
      this.industriesChallenge.forEach(function(item, i) {
        fd.append("challenge_priority[" + i + "]", item.priority);
        fd.append("challenge_title[" + i + "]", item.title);
        fd.append("challenge_description[" + i + "]", item.description);
      });

      /* =========================
       * SOLUTION
       * ========================= */
      this.solutions.forEach(function(item, i) {
        fd.append("solution_priority[" + i + "]", item.priority);
        fd.append("solution_title[" + i + "]", item.title);
        fd.append("solution_description[" + i + "]", item.description);

        if (item.image instanceof File) {
          fd.append("solution_image[" + i + "]", item.image);
        }

        if (item.icon instanceof File) {
          fd.append("solution_icon[" + i + "]", item.icon);
        }
      });

      /* =========================
       * BENEFIT
       * ========================= */
      this.benefits.forEach(function(item, i) {
        fd.append("benefit_priority[" + i + "]", item.priority);
        fd.append("benefit_title[" + i + "]", item.title);
        fd.append("benefit_description[" + i + "]", item.description);

        if (item.icon instanceof File) {
          fd.append("benefit_icon[" + i + "]", item.icon);
        }
      });

      /* =========================
       * TESTIMONIAL
       * ========================= */
      this.testimonials.forEach(function(item, i) {
        fd.append("testimonial_priority[" + i + "]", item.priority);
        fd.append("testimonial_name[" + i + "]", item.name);
        fd.append("testimonial_quote[" + i + "]", item.testimoni);
        fd.append("testimonial_company[" + i + "]", item.company);

        if (item.video) {
          fd.append("testimonial_video[" + i + "]", item.video);
        }

        if (item.image instanceof File) {
          fd.append("testimonial_avatar[" + i + "]", item.image);
        }
      });

      /* =========================
       * FAQ
       * ========================= */
      this.faqs.forEach(function(item, i) {
        fd.append("faq_priority[" + i + "]", item.priority);
        fd.append("faq_question[" + i + "]", item.question);
        fd.append("faq_answer[" + i + "]", item.answer);
      });

      /* =========================
       * REQUEST
       * ========================= */
      try {
        await axios.post(
            process.env.VUE_APP_DOMAIN_URL + "/v1/industries",
            fd,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                "Content-Type": "multipart/form-data"
              }
            }
        );

        Swal.fire({
          icon: "success",
          title: "Industries Data Created",
          showConfirmButton: false,
          timer: 2000
        });
        this.isDisableSubmit = false;

        this.$router.push("/management/industry/list");

      } catch (err) {
        this.isDisableSubmit = false;

        let message = "Something went wrong";

        if (
            err.response &&
            err.response.data &&
            err.response.data.desc
        ) {
          message = err.response.data.desc.id || err.response.data.desc.en;
        }

        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: message
        });
      }
    },
    async getHashtagList() {
      try {
        const res = await axios.get(
            `${process.env.VUE_APP_DOMAIN_URL}/v1/corporate_action_hashtag/data`,
            {
              params: {
                per_page: 10000,
                status: "ACTIVE"
              },
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json"
              }
            }
        );

        this.optionsHashtag = res.data.data
            .filter(item => item.status === "ACTIVE")
            .map(item => item.corporate_action_hashtag_title);
      } catch (err) {
        console.error(err);
      }
    },

    handleHashtag(value) {
      this.form.hashtag_ids = value;
    }
  },
  mounted() {
    this.getHashtagList();
  }
};
</script>
